import saveLinkData from "./saveLinkData";
import {apiV2PayByLinkSend} from "../../../../../../../api/merchant/payByLink";

export default (data, id) => {
  return saveLinkData(data, id).then(({id: newID}) => {
    return apiV2PayByLinkSend({id: newID || id}).then(() => ({id: newID || id}));
  })
}
